<template>
  <div class="modal fade" id="addRole" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
     <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Add Role</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="form-label">Role Name</label>
              <div class="input-group">
                  <input v-model="projectRoleForm.roleName" class="form-control" required>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn" @click="TryAddProjectRole()" data-bs-dismiss="modal" style="background-color: #56759c;color: #ffffff">
                <font-awesome-icon icon="save"/>
                <span class="mx-1">Save</span>
              </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"

    export default {
        name: "AddRole",
        props: ['isActiveProjectRoleModal', 'projectId'],
        data() {
            return {
                projectRoleForm: {
                    id: 0,
                    roleName: "",
                    projectId: 0

                }
            }
        },
        computed: {
            ...mapState('roles', ['roles']),
        },
        methods: {
            ...mapActions('roles', ['addRole', 'getRolesOfProject']),

            openCloseRoleModal() {
                this.projectRoleForm.roleName = "";
                this.$emit('openCloseRoleModal');
            },
            async TryAddProjectRole() {
                try {
                    this.projectRoleForm.projectId = parseInt(this.projectId);
                    await this.addRole(this.projectRoleForm);
                    console.log('add role modal');
                    console.log(this.projectRoleForm);
                    await this.getRolesOfProject(this.projectRoleForm.projectId);
                    await this.openCloseRoleModal();
                    this.$notify({title: "Success", type: "success", text: "Successfully added role."})
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e})
                }
            },
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    //this.$emit('openCloseRoleModal');
                    this.isActiveProjectRoleModal = false;
                }
            })
        },
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
